import { openPopup } from '../../modules/Popup.js';
// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

jQuery(function($){
    let $productPage = $('.single-product-page');
    if ($productPage.length == 0){
        return;
    }


    $(document).on('input change', '.add-to-cart__qty', function() {
        let quantity = $(this).val();
        $('.add_to_cart_button').attr('data-quantity', quantity);
        $('.popup-cart-qty').text(quantity);
    });


    $(document.body).on('added_to_cart', function(event, fragments, cart_hash, button) {
        openPopup('add-to-cart');
    });

    let thumbSwiper = new Swiper('.product-gallery__thumbnails.main-slider', {
        loop: true,
        lazy: true, 
        slidesPerView: 'auto',
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
    });

    // Get the data-slide-to-slide value using jQuery
    var $mainSliderElement = $('.product-gallery__slider.main-slider');
    var initialSlide = $mainSliderElement.data('initial-slide') || 0;
  
    // Initialize the Swiper instance
    var mainSwiper = new Swiper('.product-gallery__slider.main-slider', {
        loop: true,
        lazy: true,
        slidesPerView: 1,
        initialSlide: parseInt(initialSlide, 10), // Set the initial slide dynamically
        navigation: {
            nextEl: '.product-gallery__next',
            prevEl: '.product-gallery__prev',
        },
        thumbs: {
            swiper: thumbSwiper,
        }
    });



    const urlParams = new URLSearchParams(window.location.search);

    // Read uitstraling and deurgrootte from URL, or fallback to null
    let uitstraling = urlParams.get('uitstraling') || null;
    let deurgrootte = urlParams.get('deurgrootte') || null;
    let zijlichten = urlParams.get('zijlichten') || null;

    function filterSlidesByProfile() {
        if (!mainSwiper) return; // Safety check in case Swiper isn't initialized yet
    
        const $slides = $('.product-gallery__slider.main-slider .swiper-slide');
    
        let targetIndex = null;
    
        $slides.each(function (index) {
            const $slide = $(this);
    
            let matchUitstraling = true;
            let matchDeurgrootte = true;
            let matchZijlichten = true;
    
            // Only check uitstraling if the slide has an uitstraling-related class
            if ($slide.hasClass('uitstraling')) {
                matchUitstraling = uitstraling ? $slide.hasClass(uitstraling) : true;
            }
    
            // Only check deurgrootte if the slide has a deurgrootte-related class
            if ($slide.hasClass('deurgrootte')) {
                matchDeurgrootte = deurgrootte ? $slide.hasClass(deurgrootte) : true;
            }

            // Only check deurgrootte if the slide has a deurgrootte-related class
            if ($slide.hasClass('zijlichten')) {
                matchZijlichten = zijlichten ? $slide.hasClass(zijlichten) : true;
            }
    
            if (matchUitstraling && matchDeurgrootte && matchZijlichten) {
                targetIndex = index;
                return false; // Break loop, we found the first match
            }
        });
    
        if (targetIndex !== null) {
            mainSwiper.slideToLoop(targetIndex);
        }
    }
    
    
    $('.config__stap input').on('change', function () {
        const value = $(this).val().toLowerCase();
        

        if (value.includes('plat')) {
            uitstraling = 'plat';
        } else if (value.includes('rond')) {
            uitstraling = 'rond';
        } else if (value.includes('driehoek')) {
            uitstraling = 'driehoek';
        } else if (value.includes('minimalistisch')) {
            uitstraling = 'minimalistisch';
        } else if (value.includes('exclusief')) {
            uitstraling = 'exclusief';
        } else if (value.includes('enkel')) {
            deurgrootte = 'enkel';
        } else if (value.includes('dubbel')) {
            deurgrootte = 'dubbel';
        }
        if (value.includes('zijlicht')) {
            zijlichten = 'met-zijlichten';
        }
        else{
            zijlichten = 'geen-zijlichten';
        }


    

        filterSlidesByProfile();
    });

    filterSlidesByProfile();




});